export enum MaterialFileUpload {
	URL = 'url',
	WEBSITE_URL = 'website_url'
}